import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Text from "components/common/Text";
import { Select, MenuItem, Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CTable from "components/common/Table";
import Stack from "components/common/Stack";
import React, { useEffect, useState } from "react";
import Link from "components/common/Link";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import SearchBar from "components/common/SearchBar";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import EventIcon from "@mui/icons-material/Event";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ModelChargingPoint from "./ModelChargingPoint";
import IconButton from "components/common/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { format } from "date-fns";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

// import { chargingStationActions } from "stores/ChargingStationStore/chargingStationAction";
import { chargingStationApi } from "stores/ChargingStationStore/chargingStationApi";
import ChargingStationTemplate from "../../template/charging_Station_Template.xlsx";

import FileSaver from "file-saver";
import Button from "components/common/Button";
const ChargingStation = ({
  handleSubmitConnector,
  handleSubmitAddChPoint,
  ChargingPointData,
  handelfilterdata,
  dropdowndata,
  handleAddConnnector,
  handleChangeConnectorAdd,
  handleSubmitEditConnector,
  handleDeleteConnectorClick,
  hendleChangeConnectorAdd,
  handleSubmitEditChPoint,
  handleChargingPointModalOpen,
  isLoading,
  data,
  onChange,
  searchhandleChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  totalCount,
  page,
  limit,
  onPageChange,
  handleOpenbulk,
  handleReset,
  handleSelectionChange,
  selectedStations,
  handleDeleteStationOpen,
  networkDropdown,
  handleNetworkStatusChange,
}) => {

  const [selectedValue, setSelectedValue] = useState("");
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    handelfilterdata(value);
  };

  const [stationid, setStationId] = useState("");
  const formData = data?.results?.map((item) => ({
    id: item?.id,
    chargingNetwork: item?.chargingNetwork?.name,
    name: item.name,
    no_of_charging_points: item?.no_of_charging_points,
    type: item?.type,
    vendor_name: item?.vendor_name,
    charging_station_date: item?.charging_station_date,
    created_at: item?.created_at,
  }));
  const columns = [
    {
      field: "name",
      headerName: "Name of Charging Station",
      valueGetter: (v, d) => {
        return (
          <>
            <Checkbox
              sx={{ fontSize: "10px !important" }}
              color="success"
              checked={selectedStations.includes(d?.id)}
              onChange={() => handleSelectionChange(d?.id)}
            />
            <span>{d.name}</span>
          </>
        );
      },
    },
    {
      field: "chargingNetwork",
      headerName: "Name of Network",
    },
    {
      field: "type",
      headerName: "Type of Charging Station",
    },
    {
      field: "charging_station_date",
      headerName: "Date",
      valueGetter: (v, d) => (
        <>
          <span>{format(new Date(d?.created_at), "dd MMM yyyy")}</span>
        </>
      ),
    },
    {
      field: "no_of_charging_points",
      headerName: "Charging Points",
      valueGetter: (v, d) => {
        return (
          <>
            {d.charging_points === 0 ? (
              <Text sx={{ cursor: "pointer", color: "#19AA69" }}>
                +Add Charging Point
              </Text>
            ) : (
              <Box sx={{display:'flex',alignItems:'center',gap:'10px',height:'100%'}}>
                <Text sx={{ color: "#707070", marginLeft: "40px" }}> {d.no_of_charging_points} </Text>
                <Box
                  sx={{
                    width: "30px",
                    height: "30px",
                    background: "#19AA69",
                    borderRadius: "50px 50px",
                    float: "right",
                    textAlign: "center",
                    color: "#ffff",
                    fontSize: "21px",
                    marginRight: "40px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpen(d.id)}
                >
                  +
                </Box>
                {d.charging_points}
              </Box>
            )}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Actions",
      valueGetter: (v, d) => {
        const StationDetail = {
          pathname: `/station/details/` + d?.id,
          stationId: d?.id,
        };
        const StationEdit = {
          pathname: `/edit/station/` + d?.id,
          stationId: d?.id,
        };
        return (
          <>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              sx={{
                flexDirection: { xs: "column", md: "row", lg: "row" },
              }}
            >
              <Link href={StationDetail}>
                <IconButton
                  aria-label="show"
                  sx={{
                    color: "green",
                    cursor: "pointer",
                  }}
                >
                  <VisibilityOutlinedIcon
                    sx={{
                      fontSize: "22px",
                      opacity: "0.59",
                      // width: "95%",
                      // marginTop: "3.5px",
                    }}
                  />
                </IconButton>
              </Link>
              <Link href={StationEdit}>
                <IconButton
                  aria-label="edit"
                  sx={{
                    color: "green",
                    fontSize: "25px",
                  }}
                >
                  <EditOutlinedIcon sx={{ fontSize: "22px" }} />
                </IconButton>
              </Link>
            </Stack>
          </>
        );
      },
    },
  ];
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const [fetchexceldata, setFetchExcelData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const limit = totalCount;
      try {
        const data = await chargingStationApi.getbulkexportChargingStations({
          limit,
        });
        const Exceldata = data?.result?.results;
        setFetchExcelData(Exceldata);
      } catch (error) {
        console.error("Error fetching connector data:", error);
      }
    };

    fetchData();
  }, [totalCount]);

  const downloadAsExcel = () => {
    const chargingStation = fetchexceldata.map((d) => ({
      "Address 1:": d?.name,
      Network: d?.chargingNetwork?.name,
      "Type of Charging Station": d?.type,
      Date: d?.created_at,
      "Number Of ChargingPoint": d?.no_of_charging_points,
    }));
    const worksheet = XLSX.utils.json_to_sheet(chargingStation);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "chargingStation Data");
    XLSX.writeFile(workbook, "chargingStation.xlsx");
  };

  const handleOpen = (id) => {
    setOpen(true);
    handleChargingPointModalOpen(id);
    setStationId(id);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const downloadChargingStationTemplate = () => {
    FileSaver.saveAs(ChargingStationTemplate, "Charging Station Template.xlsx");
  };
  const filteroldest = ["latest", "oldest"];

  return (
    <>
      <Box className={classes.center} sx={{ marginTop: "1.6rem" }}>
        <Card>
          <CardContent>
            <Box sx={{ marginBottom: "20px" }}>
              <Stack
                direction={{ sm: "column", xs: "column", md: "row" }}
                spacing={2}
                justifyContent="space-between"
              >
                <Text
                  variant="h5"
                  color="#707070"
                  sx={{ fontSize: "22px", marginBottom: "40px" }}
                >
                  Charging Station
                </Text>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* <Chip
                    onClick={ handleOpenbulk}
                    className={classes.chipmenuitem}
                    label="+ Add Bulk " 
                  />
                    <Chip
                    onClick={() => downloadChargingStationTemplate()}
                    className={classes.chipmenuitem}
                    label="Download Template"
                  /> */}
                  <span
                    onClick={() => downloadAsExcel()}
                    className={classes.exportfile}
                  >
                    <FileDownloadIcon className={classes.fileDownload_icon} />
                    Export Report
                  </span>
                  <span
                    onClick={() => handleAddConnnector("AddChargingStation")}
                    className={classes.downloadbutton}
                  >
                    +Add Station
                  </span>
                </div>
              </Stack>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: "20px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: "20px",
                }}
              >
                <Box
                  style={{ maxWidth: 173, minWidth: 173, marginRight: "10px" }}
                >
                  <FormControl fullWidth size="small">
                    <InputLabel
                      sx={{ fontSize: "15px", color: "#9e9e9e" }}
                      id="demo-simple-select-label"
                    >
                      Select Filter
                    </InputLabel>

                    <Select
                      sx={{ fontSize: "15px" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Filter"
                      value={selectedValue}
                      onChange={handleChange}
                    >
                      {filteroldest.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                <Box
                  style={{ maxWidth: 173, minWidth: 173, marginRight: "10px" }}
                >
                  <FormControl fullWidth size="small">
                    <InputLabel
                      sx={{ fontSize: "15px", color: "#9e9e9e" }}
                      id="demo-simple-select-label"
                    >
                      Select Network
                    </InputLabel>

                    <Select
                      sx={{ fontSize: "15px" }}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Select Filter"
                      // value={selectedValue}
                      onChange={handleNetworkStatusChange}
                    >
                      {networkDropdown.map((option, index) => (
                        <MenuItem key={index} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ maxWidth: 200, minWidth: 200 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel
                      sx={{ fontSize: "14px" }}
                      className={classes.datePickerInput}
                      id="daterange-label"
                    >
                      Date Range
                    </InputLabel>
                    <OutlinedInput
                      sx={{ height: "37px", fontSize: "11px" }}
                      label="Date Range"
                      className={classes.table_date}
                      id="outlined-adornment-amount"
                      value={
                        fromat_date_from && fromat_date_to
                          ? `${fromat_date_from} - ${fromat_date_to}`
                          : ""
                      }
                      onClick={handleDatePickerOpen}
                      endAdornment={
                        <InputAdornment
                          position="end"
                          sx={{ cursor: "pointer" }}
                        >
                          <EventIcon />
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Box>
                <Box sx={{ marginLeft: "10px" }}>
                  <Button
                    disabled={selectedStations.length === 0}
                    sx={{
                      background:
                        selectedStations.length > 0 ? "#f44336" : "#707070",
                        fontSize:'0.85rem'
                    }}
                    onClick={handleDeleteStationOpen}
                  >
                    {selectedStations.length > 0
                      ? "Delete Selected"
                      : "Delete"}
                  </Button>
                </Box>
                <Dialog
                  open={datePickerOpen !== undefined ? datePickerOpen : false}
                  onClose={handleDatePickerClose}
                  title="Select a date range"
                  children={
                    <DatePickerModal
                      onClose={handleDatePickerClose}
                      onDatePickerSub={onDatePickerSub}
                      from_date={from_date}
                      to_date={to_date}
                      handleChange={onChange}
                      handleReset={handleReset}
                    />
                  }
                />
              </div>
              <Box className={classes.searchBoxContainer}>
                <SearchBar
                  onSearchChange={(value) =>
                    searchhandleChange("inputsearch", value)
                  }
                />
              </Box>
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              <CTable
                columns={columns}
                data={formData || []}
                isLoading={isLoading}
                pagination={true}
                count={totalCount + 1}
                page={page}
                rowsPerPage={limit}
                onPageChange={onPageChange}
              ></CTable>
            </Box>
            <ModelChargingPoint
              handleDeleteConnector={handleDeleteConnectorClick}
              hendleChangeConnectorAdd={hendleChangeConnectorAdd}
              handleSubmitConnector={handleSubmitConnector}
              handleSubmitAddChPoint={handleSubmitAddChPoint}
              ChargingPointData={ChargingPointData}
              dropdowndata={dropdowndata}
              handleChangeConnectorAdd={handleChangeConnectorAdd}
              open={open}
              handleSubmitEditChPoint={handleSubmitEditChPoint}
              stationid={stationid}
              handleSubmitEditConnector={handleSubmitEditConnector}
              handleClose={handleClose}
            />
          </CardContent>
        </Card>
      </Box>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  downloadbutton: {
    background: "#19AA69",
    width: "130px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    height: "35px",
    borderRadius: "30px",
    color: "white",

    "@media (max-width:768px)": {
      float: "right",
      position: "relative",
      top: "35px",
    },
  },
  chipmenuitem: {
    alignItems: "center",
    padding: "0px 8px",
    backgroundColor: "unset !important",
    color: "#004AAD",
    marginRight: "10px",
    border: "1px solid #004AAD",
    height: "35px",
  },
  exportfile: {
    background: "#19AA69",
    cursor: "pointer",
    height: "25px",
    float: "right",
    width: "120px",
    marginRight: "10px",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },
  fileDownload_icon: {
    fontSize: "20px",
    marginTop: "3px",
  },
}));
export default ChargingStation;
